import { OnlineMeetingProviderType } from '../OnlineMeetingProviderType';

export const isProviderTypeTeams = (providerType: OnlineMeetingProviderType) =>
    providerType === 'TeamsForBusiness';
